module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<ul class="tags list-unstyled list-inline">\n</ul>\n<div class="input" contenteditable="true"/>\n\n\n\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/components/tag_input/TagInputView.tpl
// module id = 3056
// module chunks = 0